import React, { useContext, useEffect, useState } from 'react'
import SideNavItem from '../components/SideNavItem'
import { faArrowLeft, faChevronLeft, faDashboard, faDiagnoses, faLocation, faPaperPlane, faPlus, faProjectDiagram, faSignOut, faUserCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ChevronLeft } from 'react-feather'
import Modal from '../components/Modal'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import authService from '../authentication'
import SendInviteModal from '../components/SendInviteModal'
import AppContext from '../contexts/AppContext'
import ModalsContext from '../contexts/ModalsContext'
import NavBarLayout from './NavBarLayout'
import 'react-tooltip/dist/react-tooltip.css'
import { Tooltip } from 'react-tooltip'
import { toast } from 'react-toastify'
import instance from '../api/client'



export default function SideBarLayout2({ children, title }) {
  const [hidden, setHidden] = useState(true)
  const [iMHidden, setIMHidden] = useState(true)
  const [selectedNav, setSelectedNav] = useState('Dashboard')
  const { user, setUser, sidebarOpen, setsidebarOpen } = useContext(AppContext)
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const dashboardIcon = {
    viewBox: "0 0 15 15", fill: "currentColor", fillRule: "evenodd",
    d: "M2.8 1h-.05c-.229 0-.426 0-.6.041A1.5 1.5 0 001.04 2.15C1 2.324 1 2.52 1 2.75V5.25c0 .229 0 .426.041.6A1.5 1.5 0 002.15 6.96C2.324 7 2.52 7 2.75 7H5.25c.229 0 .426 0 .6-.041A1.5 1.5 0 006.96 5.85C7 5.676 7 5.48 7 5.25V2.75c0-.229 0-.426-.041-.6A1.5 1.5 0 005.85 1.04C5.676 1 5.48 1 5.25 1H2.8zm-.417 1.014c.043-.01.11-.014.417-.014h2.4c.308 0 .374.003.417.014a.5.5 0 01.37.37c.01.042.013.108.013.416v2.4c0 .308-.003.374-.014.417a.5.5 0 01-.37.37C5.575 5.996 5.509 6 5.2 6H2.8c-.308 0-.374-.003-.417-.014a.5.5 0 01-.37-.37C2.004 5.575 2 5.509 2 5.2V2.8c0-.308.003-.374.014-.417a.5.5 0 01.37-.37zM9.8 1h-.05c-.229 0-.426 0-.6.041A1.5 1.5 0 008.04 2.15C8 2.324 8 2.52 8 2.75V5.25c0 .229 0 .426.041.6A1.5 1.5 0 009.15 6.96C9.324 7 9.52 7 9.75 7H12.25c.229 0 .426 0 .6-.041A1.5 1.5 0 0013.96 5.85C14 5.676 14 5.48 14 5.25V2.75c0-.229 0-.426-.041-.6A1.5 1.5 0 0012.85 1.04C12.676 1 12.48 1 12.25 1H9.8zm-.417 1.014c.043-.01.11-.014.417-.014h2.4c.308 0 .374.003.417.014a.5.5 0 01.37.37c.01.042.013.108.013.416v2.4c0 .308-.004.374-.014.417a.5.5 0 01-.37.37c-.042.01-.108.013-.416.013H9.8c-.308 0-.374-.003-.417-.014a.5.5 0 01-.37-.37C9.004 5.575 9 5.509 9 5.2V2.8c0-.308.003-.374.014-.417a.5.5 0 01.37-.37zM2.75 8H5.25c.229 0 .426 0 .6.041A1.5 1.5 0 016.96 9.15C7 9.324 7 9.52 7 9.75V12.25c0 .229 0 .426-.041.6A1.5 1.5 0 015.85 13.96C5.676 14 5.48 14 5.25 14H2.75c-.229 0-.426 0-.6-.041A1.5 1.5 0 011.04 12.85C1 12.676 1 12.48 1 12.25V9.75c0-.229 0-.426.041-.6A1.5 1.5 0 012.15 8.04C2.324 8 2.52 8 2.75 8zm.05 1c-.308 0-.374.003-.417.014a.5.5 0 00-.37.37C2.004 9.425 2 9.491 2 9.8v2.4c0 .308.003.374.014.417a.5.5 0 00.37.37c.042.01.108.013.416.013h2.4c.308 0 .374-.004.417-.014a.5.5 0 00.37-.37c.01-.042.013-.108.013-.416V9.8c0-.308-.003-.374-.014-.417a.5.5 0 00-.37-.37C5.575 9.004 5.509 9 5.2 9H2.8zm7-1h-.05c-.229 0-.426 0-.6.041A1.5 1.5 0 008.04 9.15C8 9.324 8 9.52 8 9.75V12.25c0 .229 0 .426.041.6A1.5 1.5 0 009.15 13.96c.174.041.371.041.6.041H12.25c.229 0 .426 0 .6-.041a1.5 1.5 0 001.109-1.109c.041-.174.041-.371.041-.6V9.75c0-.229 0-.426-.041-.6A1.5 1.5 0 0012.85 8.04C12.676 8 12.48 8 12.25 8H9.8zm-.417 1.014c.043-.01.11-.014.417-.014h2.4c.308 0 .374.003.417.014a.5.5 0 01.37.37c.01.042.013.108.013.416v2.4c0 .308-.004.374-.014.417a.5.5 0 01-.37.37c-.042.01-.108.013-.416.013H9.8c-.308 0-.374-.004-.417-.014a.5.5 0 01-.37-.37C9.004 12.575 9 12.509 9 12.2V9.8c0-.308.003-.374.014-.417a.5.5 0 01.37-.37z", clipRule: "evenodd"
  }

  const projectIcon = {
    viewBox: "0 0 1024 1024", fill: "currentColor",
    d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM368 744c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464zm192-280c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184zm192 72c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256z"
  }

  const altprojectIcon = {
    viewBox: "0 0 1024 1024", fill: "currentColor",
    d: "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM612 746H412V546h200v200zm268-268H680V278h200v200z"
  }

  const locationIcon = { viewBox: "0 0 24 24", fill: "currentColor", d: "M21.15 2.86a2.89 2.89 0 00-3-.71L4 6.88a2.9 2.9 0 00-.12 5.47l5.24 2a.93.93 0 01.53.52l2 5.25A2.87 2.87 0 0014.36 22h.07a2.88 2.88 0 002.69-2l4.73-14.17a2.89 2.89 0 00-.7-2.97zM20 5.2l-4.78 14.18a.88.88 0 01-.84.62.92.92 0 01-.87-.58l-2-5.25a2.91 2.91 0 00-1.67-1.68l-5.25-2A.9.9 0 014 9.62a.88.88 0 01.62-.84L18.8 4.05A.91.91 0 0120 5.2z" }

  const signoutIcon = { viewBox: "0 0 24 24", fill: "currentColor", d: "M4 12a1 1 0 001 1h7.59l-2.3 2.29a1 1 0 000 1.42 1 1 0 001.42 0l4-4a1 1 0 00.21-.33 1 1 0 000-.76 1 1 0 00-.21-.33l-4-4a1 1 0 10-1.42 1.42l2.3 2.29H5a1 1 0 00-1 1zM17 2H7a3 3 0 00-3 3v3a1 1 0 002 0V5a1 1 0 011-1h10a1 1 0 011 1v14a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-2 0v3a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3z" }

  const newprojectIcon = { viewBox: "0 0 24 24", fill: "currentColor", d: "M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z" }

  const homeIcon = { viewBox: "0 0 1024 1024", fill: "currentColor", d: "M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.9 63.9 0 00-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0018.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z" }


  const navs = [
    { to: '/dashboard', icon: dashboardIcon, label: 'Dashboard' },
    { to: '/workarea', icon: projectIcon, label: 'Projects' },
    // { to: '', icon: locationIcon, label: 'Locations' },
    { to: '/models', icon: altprojectIcon, label: 'Models' },
  ]

  const [userInfo, setUserInfo] = useState({})

  const getUserInfo = async (projectCode) => {
    try {
        const { data, status } = await instance.get(`/user/view-profile`, {
            headers: {
                Authorization: `Bearer ${authService.getCurrentUser()}`
            }
        })
        setUserInfo(data)
        console.log('User: ', data)
    } catch (error) {
        toast.error(`Error: ${error}`, {
            position: toast.POSITION.TOP_CENTER
        });
    }
}

  useEffect(()=>{
    getUserInfo()
  },[])


  return (
    <ModalsContext.Provider value={{ setIMHidden, setHidden }}>
      <SendInviteModal hidden={iMHidden} setHidden={setIMHidden} />
      <Modal hidden={hidden} setHidden={setHidden} />

      <div style={{ fontFamily: 'MavenPro' }} className='flex overflow-x-hidden h-[100vh]'>
        <div className={`flex fixed h-screen top-0 duration-300 z-50 ${sidebarOpen ? 'left-0' : 'left-[-250px]'} `}>
          <div className={`w-56 flex-col h-screen bg-gradient-to-b from-[#163F63] to-[#0E3458] `} >

            <div className=''>

              <div className='flex justify-end items-center'>
                <button onClick={() => setsidebarOpen(false)} className={`text-white text-right p-3 bg-[#2A578E] rounded-xl h-14`}>
                  <ChevronLeft size={20} />
                </button>
              </div>
              <div className='flex justify-center items-center'>
                <img className='' src={require('../assets/big_user.png')} alt='logo' style={{ height: '9rem' }} />
              </div>

              <div className='text-center text-lg uppercase text-white truncate mt-2'>{user.sub}</div>
              <div className='text-center text-white truncate mt-2'>{userInfo.email}</div>
              {/* <div className='text-center uppercase text-white truncate'>{user.sub}</div> */}
              {/* <div className='flex items-center justify-center '>
                <hr className=' w-2/3 border-3 border-slate-400 mx-2  '></hr>
              </div> */}
            </div>

            <div className='flex flex-col items-center justify-center my-14'>

              <div className='w-full'>
                {navs.map((nav) => (
                  <Link key={nav.label} to={nav.to}>

                    <SideNavItem nav={nav} onClick={() => { setSelectedNav(nav.label) }} selected={nav.to == pathname ? true : false} icon={nav.icon} >{nav.label}</SideNavItem>
                  </Link>
                ))}
              </div>
            </div>

            <div className='flex flex-col'>
              <div className='flex items-center justify-center '>
                <hr className=' w-2/3 border-3 border-slate-400 mx-2 mt-3 '></hr>
              </div>
              <p className='flex gap-1 font-dmsans text-xs m-2 mx-auto text-center mt-2 text-slate-500 '>
                <svg className='mt-0.5' viewBox="0 0 16 16" fill="currentColor" height="1em" width="1em">
                  <path fillRule="evenodd" d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8zm9 3a1 1 0 11-2 0 1 1 0 012 0zM6.92 6.085c.081-.16.19-.299.34-.398.145-.097.371-.187.74-.187.28 0 .553.087.738.225A.613.613 0 019 6.25c0 .177-.04.264-.077.318a.956.956 0 01-.277.245c-.076.051-.158.1-.258.161l-.007.004a7.728 7.728 0 00-.313.195 2.416 2.416 0 00-.692.661.75.75 0 001.248.832.956.956 0 01.276-.245 6.3 6.3 0 01.26-.16l.006-.004c.093-.057.204-.123.313-.195.222-.149.487-.355.692-.662.214-.32.329-.702.329-1.15 0-.76-.36-1.348-.863-1.725A2.76 2.76 0 008 4c-.631 0-1.155.16-1.572.438-.413.276-.68.638-.849.977a.75.75 0 101.342.67z" />
                </svg>
                Getting started and help
              </p>

              <SideNavItem onClick={() => {
                authService.removeCurrentUser()
                setUser(null)
                navigate('/login')
              }}
                icon={signoutIcon} className="px-6">
                {'Sign out'}
              </SideNavItem>
            </div>
          </div>
        </div>


        <div className={`${sidebarOpen ? 'left-[-200px]' : 'left-0'} z-50 duration-300 flex flex-col p-2 bg-gray-900 rounded-r-lg fixed  top-1/2 transform -translate-y-1/2`}>
          <div className='flex flex-col py-2'>
            <Link to={'/workarea'}>
              <button data-tooltip-content={'Create Project'} data-tooltip-id='cp' className='p-2 text-teal-400 bg-gray-800 hover:text-white rounded-3xl hover:rounded-xl hover:bg-teal-600 transition-all ease-linear duration-200'>
                <svg fill={newprojectIcon.fill} fillRule={newprojectIcon.fillRule || ''} clipRule={newprojectIcon.clipRule || ''} viewBox={newprojectIcon.viewBox} height={24} width={24}><path d={newprojectIcon.d} /></svg>
              </button>
              <Tooltip place='right' id={'cp'} />
            </Link>
            {navs.map((nav) => (
              <Link key={nav.label} to={nav.to}>
                <button data-tooltip-content={nav.label} data-tooltip-id={nav.label} className='p-2 text-teal-400 bg-gray-800 rounded-3xl hover:text-white hover:rounded-xl hover:bg-teal-600 mt-2 transition-all ease-linear duration-200'>
                  <svg fill={nav.icon.fill} fillRule={nav.icon.fillRule || ''} clipRule={nav.icon.clipRule || ''} viewBox={nav.icon.viewBox} height={24} width={24}><path d={nav.icon.d} /></svg>
                </button>
                <Tooltip place='right' id={nav.label} />
              </Link>
            ))}
          </div>
        </div>


        <div className={`flex flex-col ${sidebarOpen ? `w-[90%] ml-56` : 'w-full'} transition-all ease-linear duration-300`}>

          <NavBarLayout title={title} />
          {/* <div onClick={()=>{navigate(-1)}} className='w-full flex ml-10 my-4'>
            <div className=' cursor-pointer text-gray-600 hover:text-red-600 font-semibold'><FontAwesomeIcon icon={faArrowLeft} size='1x' /> Back</div>
          </div> */}
          <div className={`md:flex w-full bg-gray-100 h-[100.0vh]`}>
            {children}
          </div>
        </div>

      </div>

    </ModalsContext.Provider>
  )
}